import { render } from "./deleteDeviceModal.vue?vue&type=template&id=6ac755b8"
import script from "./deleteDeviceModal.vue?vue&type=script&lang=js"
export * from "./deleteDeviceModal.vue?vue&type=script&lang=js"
script.render = render

export default script